import { useRef, useState } from 'react';
import { Controller } from 'react-hook-form';

import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import NoImage from '/no-image.png';

import { ImageCropper } from '../ImageCropper';
import { ImageFinder } from '../ImageFinder';
import { ErrorMessage } from './ErrorMessage';

export const ImageSelector = ({ name, size = 200 }: { name: string; size?: number }) => {
  const scrollToRef = useRef<HTMLDivElement | null>(null);
  const [cropperOpen, setCropperOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Controller
      name={name}
      rules={{ required: true }}
      render={({ field }) => (
        <div ref={field.ref} id={name}>
          <ErrorMessage fieldName={name} />

          <div className='flex justify-center'>
            <img
              src={field.value || NoImage}
              alt='Selected'
              onClick={() => {
                setCropperOpen(true);
                setSearchOpen(false);
              }}
              className='mt-2 mb-4 max-h-48 cursor-pointer rounded-md'
            />
          </div>
          <div className='flex flex-col gap-2 lg:flex-row lg:justify-center'>
            <Button
              id='upload-image'
              className='override-button-sm!'
              onClick={() => {
                setCropperOpen(true);
                setSearchOpen(false);
              }}
            >
              <UploadOutlined /> Enviar Imagem
            </Button>
            <Button
              id='search-image'
              className='override-button-sm!'
              onClick={() => {
                setCropperOpen(false);
                setSearchOpen(true);
              }}
            >
              <SearchOutlined ref={scrollToRef} /> Pesquisar Imagem
            </Button>
          </div>
          {cropperOpen && (
            <ImageCropper
              open={cropperOpen}
              size={size}
              onCrop={croppedImage => {
                if (croppedImage) {
                  field.onChange(croppedImage);
                }

                setCropperOpen(false);
              }}
            />
          )}
          {searchOpen && (
            <ImageFinder
              open={searchOpen}
              onCrop={selectedImage => {
                if (selectedImage) {
                  field.onChange(selectedImage);
                }

                setSearchOpen(false);
              }}
            />
          )}
        </div>
      )}
    />
  );
};
